export default function MaintenanceMockService($http, $q, gettextCatalog, appSettings) {
  'ngInject';
  this.getPlans = function () {
    return $http.get('./app/fixtures/maintenance/plans.json');
  };

  this.getPlan = function (planId) {
    var def = $q.defer();
    $http.get('./app/fixtures/maintenance/plans.json').then(
      function (response) {
        for (var i = 0; i < response.data.length; i++) {
          if (response.data[i].id == planId) {
            response.data = response.data[i];
            return def.resolve(response);
          }
        }
        return def.reject(gettextCatalog.getString('Id not in fixtures'));
      },
      function (response) {
        return def.reject(response);
      }
    );
    return def.promise;
  };

  this.updatePlan = function (plan) {
    if (!plan) return;

    if (appSettings.FixturesModeEnabled) {
      return this.getPlan(plan.id);
    }

    var endpoint = appSettings.InReachApiEndpoint + '/maintenance/plans/' + plan.id;

    return $http.put(endpoint, plan);
  };

  this.createPlan = function (plan) {
    if (!plan) return;

    var def = $q.defer();
    $http.get('./app/fixtures/maintenance/plans.json').then(
      function (response) {
        response.data = response.data[0];
        return def.resolve(response);
      },
      function (response) {
        return def.reject(response);
      }
    );
    return def.promise;
  };

  this.deletePlan = function (plan) {
    if (!plan) return;

    var def = $q.defer();
    def.resolve(gettextCatalog.getString('Deleted'));
    return def.promise;
  };

  this.getPlanTasks = function (plan) {
    if (!plan) return;

    if (!plan.id) {
      plan = {
        id: plan
      };
    }

    var def = $q.defer();
    $http.get('./app/fixtures/maintenance/tasks.json').then(
      function (response) {
        return def.resolve(response);
      },
      function (response) {
        return def.reject(response);
      }
    );
    return def.promise;
  };

  this.getTaskInPlan = function (plan, taskId) {
    if (!plan || !taskId) return;

    if (!plan.id) {
      plan = {
        id: plan
      };
    }

    var def = $q.defer();
    $http.get('./app/fixtures/maintenance/tasks.json').then(
      function (response) {
        for (var i = 0; i < response.data.length; i++) {
          if (response.data[i].id == taskId) {
            response.data = response.data[i];
            return def.resolve(response);
          }
        }

        return def.reject(gettextCatalog.getString('Id not in fixture data'));
      },
      function (response) {
        return def.reject(response);
      }
    );
    return def.promise;
  };

  this.createTaskInPlan = function (plan, task) {
    if (!plan || !task) return;

    if (!plan.id) {
      plan = {
        id: plan
      };
    }

    var def = $q.defer();
    $http.get('./app/fixtures/maintenance/tasks.json').then(
      function (response) {
        response.data = response.data[0];
        return def.resolve(response);
      },
      function (response) {
        return def.reject(response);
      }
    );
    return def.promise;
  };

  this.updateTaskInPlan = function (plan, task) {
    if (!plan || !task) return;

    if (!plan.id) {
      plan = {
        id: plan
      };
    }

    var def = $q.defer;
    def.resolve(task);
    return def.promise;
  };

  this.deleteTaskInPlan = function (plan, taskId) {
    if (!plan || !taskId) return;

    if (!plan.id) {
      plan = {
        id: plan
      };
    }

    var def = $q.defer();
    def.resolve('Deleted');
    return def.promise;
  };

  this.getStatus = () => {
    var def = $q.defer();

    $http.get('./app/fixtures/maintenance/status.json').then(
      function (response) {
        return def.resolve(response);
      },
      function (response) {
        return def.reject(response);
      }
    );

    return def.promise;
  };
}